<template>
  <div class="myorder mt30">
    <!--<code> {{ order }}</code>-->
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class=" myorders">
            <div>
              <div class="panel-collapse collapse in" v-for="order  in order">
                <div class="panel-body print-area">
                  <div class="order-items">
                    <div class="row">
                      <div class="col-md-9 left-area"><h3 class="c-title mb10">Billing Details</h3>
                        <p class="green-color thanks-msg mb10">Thank you for your Order. </p>
                        <table class="table  table-responsive order-summary">
                          <tr>
                            <td>ORDER ID<br> <span class="base-color">#{{order.id}}</span></td>
                            <td>DATE<br> <span class="base-color">{{order.created_at | formatDate}}</span></td>
                            <td>PAYMENT METHOD<br> <span class="base-color">
                                <span class="base-color" v-if="order.payment_type==1"> Bkash - {{order.transaction_number}}</span>
                                  <span class="base-color" v-else-if="order.payment_type==2"> Cash On Delivery - {{order.transaction_number}}</span>
                               </span></td>
                            <td>TOTAL<br>
                              <span class="base-color">{{ order.order_total }} &#8364;</span>
                            </td>
                            <td>ORDER STATUS<br>
                              <span class="orange-color" v-if="order.status==0"> Pending</span>
                              <span class="green-color" v-else-if="order.status==1"> Approved</span>
                              <span class="green-color" v-else-if="order.status==2"> Complete</span>
                              <span class="red-color" v-else-if="order.status==3"> Cancel</span>
                            </td>
                          </tr>
                        </table>
                        <h3 class="c-title">Your Order</h3>
                        <table class="table  table-responsive  table-striped checkout-table">
                          <thead>
                          <tr>
                            <th>Product</th>
                            <th>Unit&nbsp;Price</th>
                            <th class="text-center">Quantity</th>
                            <th>Total</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in order_items" v-if="order.id==item.order_id">
                            <td>
                              <div v-for="product in products">
                                <div v-if="item.product_id==product.id">
                                  {{ product.name }}
                                </div>
                              </div>
                            </td>
                            <td> {{ item.unit_price }} &#8364;</td>
                            <td class="text-center"> {{item.quantity}}</td>
                            <td> {{ item.total_price }} &#8364;</td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-right">Cart Subtotal:</td>
                            <td class="base-color w500">{{ order.order_total-order.delivery_charge }} &#8364;</td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-right">Delivery Charge:</td>
                            <td class="base-color w500">{{ order.delivery_charge }} &#8364;</td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-right">Order Total:</td>
                            <td class="base-color w500">{{ order.order_total }} &#8364;</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-3 shipping-info">
                        <h3 class="c-title mt75">Customer Detail</h3>
                        <p>
                          <span>Name:</span>
                          {{ name }}
                        </p>
                        <p>
                          <span>Email:</span>
                          {{ email }}
                        </p>
                        <p>
                          <span>Phone:</span>

                          {{ phone }}
                        </p>
                        <p>
                          <span>Country:</span>

                          {{ country}}
                        </p>
                        <p>
                          <span>District:</span>
                          {{ district }}
                        </p>
                        <p>
                          <span>Area:</span>
                          {{ area }}
                        </p>
                        <p>
                          <span>Zip:</span>
                          {{ zip }}
                        </p>
                        <h3 class="c-title">Shipping Address</h3>
                        <p>
                          {{order.address}}
                        </p>
                        <!--@click="print()"-->
                        <button  @click="print()" class="btn btn-base btn-sm mt15 nonprint-area"><i class="fa fa-print"></i> PRINT NOW
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-group" id="accordion" v-for="(order ,counter) in orders">
                <div class="panel panel-default">
                  <div class="panel-collapse collapse in">
                    <div class="panel-body print-area">

                      <div class="order-items">
                        <div class="row">
                          <div class="col-md-9">
                            <h3 class="c-title mb10">Billing Details</h3>
                            <p class="green-color thanks-msg mb10">Thank you for your Order. </p>
                            <table class="table  table-responsive order-summary">
                              <tr>
                                <td>ORDER ID<br>
                                  <span class="base-color">#{{order.id}}</span>
                                </td>
                                <td>DATE<br>
                                  <span class="base-color">{{order.created_at | formatDate}}</span>
                                </td>
                                <td>PAYMENT METHOD<br>
                                  <span class="base-color" v-if="order.payment_type==1"> Bkash - {{order.transaction_number}}</span>
                                  <span class="base-color" v-else-if="order.payment_type==2"> Cash On Delivery - {{order.transaction_number}}</span>
                                  <span class="base-color" v-else></span>
                                </td>
                                <td>TOTAL<br>
                                  <span class="base-color">{{ order.order_total }} &#8364;</span>
                                </td>
                                <td>ORDER STATUS<br>
                                  <span class="orange-color" v-if="order.status==0"> Pending</span>
                                  <span class="green-color" v-else-if="order.status==1"> Approved</span>
                                  <span class="green-color" v-else-if="order.status==2"> Complete</span>
                                  <span class="red-color" v-else-if="order.status==3"> Cancel</span>


                                </td>
                              </tr>
                            </table>

                            <h3 class="c-title">Your Order</h3>
                            <table class="table  table-responsive  table-striped checkout-table">
                              <thead>
                              <tr>
                                <th>Product</th>
                                <th class="text-center">Unit&nbsp;Price</th>
                                <th class="text-center">Quantity</th>
                                <th>Total</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="item in order_items" v-if="order.id==item.order_id">
                                <td>
                                  <div v-for="product in products">
                                    <div v-if="item.product_id==product.id">
                                      {{ product.name }}
                                    </div>
                                  </div>
                                </td>
                                <td class="text-center"> {{ item.unit_price }} &#8364;</td>
                                <td class="text-center"> {{item.quantity}}</td>
                                <td> {{ item.total_price }} &#8364;</td>
                              </tr>
                              <tr>
                                <td colspan="3" class="text-right">Cart Subtotal:</td>
                                <td class="base-color w500">{{ order.order_total-order.delivery_charge }} &#8364;</td>
                              </tr>
                              <tr>
                                <td colspan="3" class="text-right">Delivery Charge:</td>
                                <td class="base-color w500">{{ order.delivery_charge }} &#8364;</td>
                              </tr>
                              <tr>
                                <td colspan="3" class="text-right">Order Total:</td>
                                <td class="base-color w500">{{ order.order_total }} &#8364;</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-md-3 shipping-info">
                            <h3 class="c-title mt75">Customer Detail</h3>
                            <p>
                              <span>Name:</span>
                              {{ name }}
                            </p>
                            <p>
                              <span>Email:</span>
                              {{ email }}
                            </p>
                            <p>
                              <span>Phone:</span>

                              {{ phone }}
                            </p>
                            <p>
                              <span>Country:</span>

                              {{ country}}
                            </p>
                            <p>
                              <span>District:</span>
                              {{ district }}
                            </p>
                            <p>
                              <span>Area:</span>
                              {{ area }}
                            </p>
                            <p>
                              <span>Zip:</span>
                              {{ zip }}
                            </p>
                            <h3 class="c-title">Shipping Address</h3>
                            <p>
                              {{order.address}}
                            </p>
                            <!--@click="print()"-->
                            <button class="btn btn-base btn-sm mt15 nonprint-area"><i class="fa fa-print"></i> PRINT NOW
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 20);
      });
  });

  import axios from 'axios';

  export default {
    data() {
      return {
        token: '',
        order: '',
        sum_cart_total: '',
        fullname: '',
        deliveryAddress: '',
        products: [],
        order_items: [],
        name: '',
        email: '',
        phone: '',
        country: '',
        district: '',
        area: '',
        zip: '',
        address: '',

      };
    },
    created: function () {
      this.loadApiData();
      this.loadProducts();
      this.fetchUserInfo();
      //localStorage.clear();
    },
    mounted() {
    },
    methods: {
      print: function () {
        window.print();
      },
      fetchUserInfo() {
        this.name = JSON.parse(localStorage.getItem("userinfo")).name;
        this.email = JSON.parse(localStorage.getItem("userinfo")).email;
        this.phone = JSON.parse(localStorage.getItem("userinfo")).phone;
        this.country = JSON.parse(localStorage.getItem("userinfo")).country;
        this.district = JSON.parse(localStorage.getItem("userinfo")).district;
        this.area = JSON.parse(localStorage.getItem("userinfo")).area;
        this.zip = JSON.parse(localStorage.getItem("userinfo")).zip;
        this.address = JSON.parse(localStorage.getItem("userinfo")).address;
      },
      loadApiData: function () {
        //localStorage.clear();
        let vm = this;
        //vm.$parent.startLoading();
        let logged_in_user_id = localStorage.getItem('logged_in_user_id');
        //alert(this.globalUrl+"myorders/"+logged_in_user_id);userId
        //pass  user  id  through  url and  catch  throun  controller
        axios.get(this.globalUrl + "myorder/" + logged_in_user_id + '/' + this.$route.params.id)
          .then(function (response) {
            //console.log(response.data);
            vm.order = response.data.data;
            //end loading
            // vm.$parent.endLoading();
          })
          .catch(() => {
            //vm.$parent.endLoading();
          });
        //alert(this.globalUrl+"myorders/"+logged_in_user_id+"/items");
        axios.get(this.globalUrl + "myorders/" + logged_in_user_id + "/items")
          .then(function (response) {
            vm.order_items = response.data;
          })
          .catch(() => {
          });
      },
      loadProducts: function () {
        //localStorage.clear();
        let vm = this;
        axios.get(this.globalUrl + "products")
          .then(function (response) {
            vm.$parent.endLoading();
            //console.log(response.data);
            vm.products = response.data.data;
            //end loading
            // vm.$parent.endLoading();
          })
          .catch((response) => {
                console.log(response);
          });
      }
    }
  };
</script>

